import { render, staticRenderFns } from "./ReportControls.vue?vue&type=template&id=0129830d&scoped=true"
import script from "./ReportControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportControls.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReportControls.vue?vue&type=style&index=0&id=0129830d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0129830d",
  null
  
)

export default component.exports